var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Watch = function () {
  function Watch(type) {
    _classCallCheck(this, Watch);
    var id = Watch.nextWatchId++;
    this.id = 'Watch_' + id;
    this.rawId = id;
    this.name = null;
    this.type = type;
    this.executedCount = 0;
    this.controller = null;
    this.modulePath = '';
    this.dependencyMap = null;
  }
  _createClass(Watch, [{
    key: 'create',
    value: function create(controller, modulePath, name) {
      this.name = name;
      this.controller = controller;
      this.modulePath = modulePath;
      return this;
    }
  }, {
    key: 'registerDependencies',
    value: function registerDependencies() {
      this.dependencyMap = this.createDependencyMap();
      this.controller.dependencyStore.addEntity(this, this.dependencyMap);
      if (this.controller.devtools) {
        this.controller.devtools.updateWatchMap(this, this.dependencyMap);
        this.controller.devtools.sendWatchMap([], [], 0, 0);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.dependencyMap) {
        this.controller.dependencyStore.removeEntity(this, this.dependencyMap);
        if (this.controller.devtools) {
          this.controller.devtools.updateWatchMap(this, null, this.dependencyMap);
          this.controller.devtools.sendWatchMap([], [], 0, 0);
        }
      }
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return {
        id: this.id,
        executedCount: this.executedCount,
        type: this.type,
        name: this.name
      };
    }
  }]);
  return Watch;
}();
Watch.nextWatchId = 0;
export default Watch;